module.exports = __webpack_public_path__ + "img/insider_program.eb72e9e1.png";